import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../hooks/index';
import { setToken } from '../store/slices/authSlice';
import { CircularProgress, Box } from '@mui/material';

interface PrivateRouteProps {
    children: React.ReactNode;
    requiredRole?: 'user' | 'admin' | 'superadmin';
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiredRole }) => {

    const { token, role } = useAppSelector((state) => state.auth);
    const location = useLocation();
    const dispatch = useAppDispatch();

    const storedToken = localStorage.getItem('token');
    const isAuthenticated = !!(token || storedToken);

    const [checking, setChecking] = React.useState(true);

    useEffect(() => {
        if (!token && storedToken) {
            dispatch(setToken(storedToken));
        }
        setChecking(false);
    }, [dispatch, token, storedToken]);

    if (checking) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // Role hierarchy for comparison
    const roleOrder = ['user', 'admin', 'superadmin'];
    const userRoleIndex = role ? roleOrder.indexOf(role) : -1;
    const requiredRoleIndex = requiredRole ? roleOrder.indexOf(requiredRole) : -1;

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (
        requiredRole &&
        (userRoleIndex === -1 || userRoleIndex < requiredRoleIndex)
    ) {
        // Insufficient role
        return <Navigate to="/dashboard" state={{ from: location, unauthorized: true }} replace />;
    }
    return <>{children}</>;
};

export default PrivateRoute; 